import React from 'react';
import { ColumnDef } from '@tanstack/table-core';
import { FleetSummary } from '../../types/Fleetsummary';
import { formatDurationFromSeconds } from '../Format';

// The API sends a count of seconds (e.g. 12524.166666666666). Earlier builds
// sent "HH:MM:SS[.ffffff]" (e.g. "00:54:41.4788732"), so that shape is still
// converted rather than rejected.
const formatDwell = (duration?: number | string): string => {
  if (duration === null || duration === undefined || duration === '') return '—';

  if (typeof duration === 'string' && duration.includes(':')) {
    const [hStr, mStr, sStr] = duration.split(':');
    const asSeconds = (Number(hStr) || 0) * 3600 + (Number(mStr) || 0) * 60 + (Number(sStr) || 0);
    return formatDurationFromSeconds(asSeconds) || '—';
  }

  return formatDurationFromSeconds(duration) || '—';
};

export const makeFleetFacilityColumns = (): ColumnDef<FleetSummary>[] => [
  {
    header: 'Station',
    accessorKey: 'stationIataCode',
    enableColumnFilter: true,
    size: 90,
    cell: ({ row }) => <span style={{ fontWeight: 700 }}>{row.original.stationIataCode}</span>,
  },
  {
    header: 'Facility',
    accessorKey: 'facilityName',
    enableColumnFilter: true,
    size: 100,
  },
  {
    header: 'Devices',
    accessorKey: 'deviceCount',
    size: 90,
    cell: ({ row }) => <span style={{ fontWeight: 600 }}>{row.original.deviceCount}</span>,
  },
  {
    header: 'Avg Dwell',
    accessorKey: 'averageDwellTimeSeconds',
    size: 100,
    cell: ({ row }) => formatDwell(row.original.averageDwellTimeSeconds),
  },
];
